import { render, staticRenderFns } from "./YearCalendarHolder.vue?vue&type=template&id=c7ba3880&scoped=true&"
import script from "./YearCalendarHolder.vue?vue&type=script&lang=js&"
export * from "./YearCalendarHolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7ba3880",
  null
  
)

export default component.exports